import { render, staticRenderFns } from "./ReportsPackagesNew.vue?vue&type=template&id=13a1a036&"
import script from "./ReportsPackagesNew.vue?vue&type=script&lang=js&"
export * from "./ReportsPackagesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports